(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    (() => {
    const sidebarQuery = window.matchMedia('(min-width: 750px)');
    const pageScrollQuery = window.matchMedia('(min-width: 990px)');
    const sidebarSelector = '.facets-block-wrapper--vertical:not(#filters-drawer)';

    const scrollport = () => {
      if (pageScrollQuery.matches) {
        const scroller = document.querySelector('.page-wrapper');
        if (scroller) {
          const rect = scroller.getBoundingClientRect();
          return { top: rect.top, bottom: rect.bottom };
        }
      }

      return { top: 0, bottom: window.innerHeight };
    };

    const fitVerticalFacets = () => {
      const sidebar = document.querySelector(sidebarSelector);
      if (!(sidebar instanceof HTMLElement)) return;

      if (!sidebarQuery.matches || sidebar.getClientRects().length === 0) {
        document.documentElement.style.removeProperty('--facets-sticky-max-height');
        return;
      }

      const port = scrollport();
      const stickyTop = Number.parseFloat(getComputedStyle(sidebar).top);
      const stuckTop = port.top + (Number.isFinite(stickyTop) ? stickyTop : 0);
      const visibleTop = Math.max(sidebar.getBoundingClientRect().top, stuckTop);
      const available = Math.floor(port.bottom - visibleTop);

      if (available > 0) {
        document.documentElement.style.setProperty('--facets-sticky-max-height', `${available}px`);
      }
    };

    let frame = 0;
    const scheduleFit = () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        fitVerticalFacets();
      });
    };

    if (window.mlFacetsStickyScrollBound) {
      scheduleFit();
      return;
    }

    window.mlFacetsStickyScrollBound = true;

    const scrollTarget = () =>
      pageScrollQuery.matches ? document.querySelector('.page-wrapper') ?? window : window;

    let currentScrollTarget = scrollTarget();
    currentScrollTarget.addEventListener('scroll', scheduleFit, { passive: true });

    window.addEventListener('resize', scheduleFit);
    sidebarQuery.addEventListener('change', scheduleFit);
    pageScrollQuery.addEventListener('change', () => {
      const nextTarget = scrollTarget();
      if (nextTarget !== currentScrollTarget) {
        currentScrollTarget.removeEventListener('scroll', scheduleFit);
        currentScrollTarget = nextTarget;
        currentScrollTarget.addEventListener('scroll', scheduleFit, { passive: true });
      }
      scheduleFit();
    });
    document.addEventListener('shopify:section:load', scheduleFit);

    if (document.querySelector('#header-component, .announcement-bar, .ml_class-breadcrumbs')) {
      const observer = new ResizeObserver(scheduleFit);
      document.querySelectorAll('#header-component, .announcement-bar, .ml_class-breadcrumbs').forEach((element) => {
        observer.observe(element);
      });
    }

    scheduleFit();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ml_block-sold-out-form"] && !Shopify.designMode) return;
  try {
    const layoutNameFields = (embed) => {
    const root = embed.shadowRoot;
    if (!root || root.querySelector('[data-ml-form-layout]')) return;

    const style = document.createElement('style');
    style.dataset.mlFormLayout = 'true';
    style.textContent = [
      'form[class*="formFieldset"], form[data-testid="form"] { display: flex !important; flex-direction: row !important; flex-wrap: wrap !important; align-items: flex-start !important; }',
      'form[class*="formFieldset"] > *, form[data-testid="form"] > * { flex: 1 1 100% !important; width: 100% !important; max-width: 100% !important; min-width: 0 !important; }',
      'form[class*="formFieldset"] > div:has(#first_name), form[class*="formFieldset"] > div:has(#last_name), form[data-testid="form"] > div:has(#first_name), form[data-testid="form"] > div:has(#last_name) { flex: 1 1 calc(50% - 6px) !important; width: calc(50% - 6px) !important; max-width: calc(50% - 6px) !important; }',
      'form[class*="formFieldset"] > div:has(#first_name) input, form[class*="formFieldset"] > div:has(#last_name) input, form[class*="formFieldset"] > div:has(#email) input, form[data-testid="form"] > div:has(#first_name) input, form[data-testid="form"] > div:has(#last_name) input, form[data-testid="form"] > div:has(#email) input { width: 100% !important; max-width: 100% !important; box-sizing: border-box; }',
    ].join(' ');
    root.appendChild(style);
  };

  const watchForm = (embed) => {
    if (embed.dataset.mlWatched === 'true') {
      layoutNameFields(embed);
      return;
    }

    embed.dataset.mlWatched = 'true';
    layoutNameFields(embed);
    if (!embed.shadowRoot) return;

    new MutationObserver(() => layoutNameFields(embed)).observe(embed.shadowRoot, {
      childList: true,
      subtree: true,
    });
  };

  const watchRoot = (container) => {
    container.querySelectorAll('shopify-forms-embed').forEach(watchForm);

    new MutationObserver(() => {
      container.querySelectorAll('shopify-forms-embed').forEach(watchForm);
    }).observe(container, { childList: true, subtree: true });
  };

  document.querySelectorAll('.ml_class-sold-out-form').forEach(watchRoot);
  } catch(e) { console.error(e); }
})();

})();
